<template>
  <el-dialog
    title="请选择共享接收企业"
    :visible.sync="visible"
    width="520px"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <!-- 共享委托人选择区 -->
    <div v-if="delegateList.length > 0" class="delegate-section">
      <div class="section-label">共享委托人：</div>
      <el-checkbox-group v-model="selectedDelegateIds">
        <el-checkbox
          v-for="item in delegateList"
          :key="getDelegateKey(item)"
          :label="getDelegateKey(item)"
        >
          {{ item.principalName || item.delegate || "-" }}
        </el-checkbox>
      </el-checkbox-group>
    </div>

    <!-- 接收企业选择区 -->
    <div class="company-section">
      <div class="section-label">接收企业：</div>
      <div class="company-tip">
        选择接收企业后，将会把客户的所有资料推送给发送企业
      </div>
      <el-table
        ref="companyTable"
        v-loading="loading"
        :data="companyList"
        :row-key="rowKey"
        border
        height="320px"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="80" align="center" />
        <el-table-column prop="businessName" label="企业名称" align="center" />
      </el-table>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="confirm">
        发 送
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getCompany,
  getLastSelectedBusinessList,
  shareSend,
} from "@/api/appApi/appapi.js";

export default {
  name: "ShareReceiveCompanyDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      visible: this.value,
      loading: false,
      btnLoading: false,
      companyList: [],
      selectedRows: [],
      delegateList: [], // 委托人列表
      selectedDelegateIds: [], // 已选委托人ID
    };
  },
  watch: {
    value(val) {
      this.visible = val;
      // if (val) this.loadData();
    },
    visible(val) {
      this.$emit("input", val);
      if (val) this.loadData();
    },
    customerId() {
      // if (this.visible) this.loadData();
    },
  },
  methods: {
    rowKey(row) {
      return row.businessId || row.id;
    },
    // 获取委托人唯一标识
    getDelegateKey(item) {
      return String(
        item.entrustInfoId ||
          item.authorizationInfoId ||
          item.id ||
          item.principalName
      );
    },
    handleSelectionChange(list) {
      this.selectedRows = list || [];
    },
    handleClosed() {
      this.selectedRows = [];
      this.delegateList = [];
      this.selectedDelegateIds = [];
      this.$nextTick(() => {
        this.$refs.companyTable && this.$refs.companyTable.clearSelection();
      });
    },
    async loadData() {
      if (!this.customerId) return;
      this.loading = true;

      // 并行加载企业列表、上次勾选企业、客户委托人信息
      const [companyRes, lastRes, detailRes] = await Promise.all([
        getCompany(),
        getLastSelectedBusinessList({ id: this.customerId }),
        // getCustomerDetail({ customerId: this.customerId, type: 1 }),
      ]);

      if (companyRes.code == "000000") {
        this.companyList = companyRes.content || [];
      }

      const lastSelectedIds = Array.isArray(lastRes.content)
        ? lastRes.content
        : [];

      // if (detailRes.code == "000000") {
      //   const info = detailRes.content || {};
      //   this.delegateList = info.authorizationInfo || [];
      //   // 默认全选委托人
      //   this.selectedDelegateIds = this.delegateList.map((item) =>
      //     this.getDelegateKey(item)
      //   );
      // }

      this.loading = false;

      this.$nextTick(() => {
        this.applyLastSelected(lastSelectedIds);
      });
    },
    applyLastSelected(idList) {
      if (!this.$refs.companyTable) return;
      this.$refs.companyTable.clearSelection();
      const idSet = new Set((idList || []).map((v) => String(v)));
      const selected = [];
      (this.companyList || []).forEach((row) => {
        const rid = String(this.rowKey(row));
        if (idSet.has(rid)) {
          this.$refs.companyTable.toggleRowSelection(row, true);
          selected.push(row);
        }
      });
      this.selectedRows = selected;
    },
    async confirm() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning("请选择共享接收企业");
        return;
      }
      // 有委托人时要求至少选择一个
      // if (
      //   this.delegateList.length > 0 &&
      //   this.selectedDelegateIds.length === 0
      // ) {
      //   this.$message.warning("请选择共享委托人");
      //   return;
      // }

      // 将选中的委托人 key 映射回 entrustInfoId
      // const entrustInfoIdList = this.delegateList
      //   .filter((item) =>
      //     this.selectedDelegateIds.includes(this.getDelegateKey(item))
      //   )
      //   .map(
      //     (item) =>
      //       item.entrustInfoId || item.authorizationInfoId || item.id
      //   )
      //   .filter((v) => v !== undefined && v !== null && v !== "");

      this.btnLoading = true;
      const payload = {
        id: this.customerId,
        businessIdList: this.selectedRows.map((v) => v.businessId || v.id),
      };
      // // 有委托人时一并提交
      // if (entrustInfoIdList.length > 0) {
      //   payload.entrustInfoIdList = entrustInfoIdList;
      // }
      const res = await shareSend(payload);
      this.btnLoading = false;
      if (res.code == "000000") {
        this.$message.success("已发送共享");
        this.visible = false;
        this.$emit("success",this.customerId);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.delegate-section,
.company-section {
  margin-bottom: 16px;
}
.section-label {
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}
.company-tip {
  color: #e6a23c;
  font-size: 13px;
  margin-bottom: 10px;
  line-height: 20px;
}
/deep/ .el-checkbox {
  margin-right: 20px;
  margin-bottom: 8px;
}
</style>
